<template>
    <v-menu v-model="menu" offset-y nudge-top="26" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-bind="attrs"
                v-on="on"
                :value="selectedPool && selectedPool.long_id"
                :label="label"
                :hint="hint"
                :persistent-hint="persistentHint"
                :rules="rules"
                :loading="loading"
                :disabled="disabled"
                :clearable="clearable"
                :placeholder="placeholder"
                :hide-details="hideDetails"
                :prepend-icon="selectedPool ? poolIcon(selectedPool) : undefined"
                append-icon="mdi-menu-down"
                outlined
                dense
                readonly
                @click:clear.stop="selectPool(null)" />
        </template>
        <ResourcePoolOptionList ref="optionList" :items="items" :selected-id="value" :loading="loading" :show-role="showRole" @select="selectPool" />
    </v-menu>
</template>

<script>
import ResourcePoolOptionList from '@/modules/user/components/ResourcePoolOptionList.vue'
import { resourcePoolIcon } from '@/modules/user/components/resourcePoolMeta'

export default {
    name: 'ResourcePoolSelector',
    components: { ResourcePoolOptionList },
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        items: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: 'Resource pool'
        },
        hint: {
            type: String,
            default: ''
        },
        persistentHint: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showRole: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        hideDetails: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menu: false
        }
    },
    computed: {
        selectedPool() {
            return this.items.find(item => this.value !== null && this.value !== undefined && String(this.value) === String(item.rpid)) || null
        }
    },
    methods: {
        poolIcon: resourcePoolIcon,
        selectPool(pool) {
            const value = pool ? pool.rpid : null
            this.$emit('input', value)
            this.$emit('change', value)
            this.$emit('select', pool)
            this.menu = false
        }
    },
    watch: {
        menu(isOpen) {
            if (isOpen && this.$refs.optionList) this.$refs.optionList.reset()
        }
    }
}
</script>
